import futura from '../assets/futura.png'
import close from '../assets/close.png'
import arrow from '../assets/arrow2.png'
import { useState } from 'react';
import SimpleReactValidator from 'simple-react-validator';
function N5({ bookid, nextPage, previuosPage, home }) {
    const [name, setName] = useState()
    const [surname, setSurname] = useState()
    const [cf, setCf] = useState('RMNGTN98M06C129E')
    const [mail, setMail] = useState()
    const [tel, setTel] = useState()
    const validator = new SimpleReactValidator({ autoForceUpdate: this });

    const [vai, setVai] = useState(false)
    const checkData = () => {
        if (validator.fieldValid('surname') && validatorDe.fieldValid('cf') && validator.fieldValid('mail') && validator.fieldValid('tel') && validator.fieldValid('name')) {
            editBook()
        }
    }


    const editBook = () => {

        fetch(document.apiURL + '/book/' + bookid, {
            method: 'PUT',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "firstname": name,
                "lastname": surname,
                "codfiscale": cf,
                "email": mail,
                "phone": tel,

            })

        })
            .then(response => response.json())
            .then(response => {
          
                //window.location = "/book/6/" + bookid
                nextPage()
            });
    }

    const validatorDe = new SimpleReactValidator({
        validators: {
            cf: {
                message: '',
                rule: (val, params, validator) => {
                    return validator.helpers.testRegex(val, /^(?:[A-Z][AEIOU][AEIOUX]|[AEIOU]X{2}|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/i) && params.indexOf(val) === -1
                },
                required: true
            }
        }
    });

    return (<>
        <div className="back-profilazione" style={{ display: 'flex', flexDirection: 'column' }}>
            <div className="square-center" >
            <div className="flex row sp" style={{ borderRadius: '16px 16px 0px 0px' }}>

<img src={arrow} onClick={()=> previuosPage()} /> 
<img src={close} onClick={()=> home()} />  

</div>
                <div className="flex row center-con sp">
                    <h2 className="c">Per chi stai prenotando l’intervento?</h2><img src={futura} className="min-fut">
                    </img>
                </div>

                <div className="input-center" style={{ marginTop: '10px' }}>
                    <div className="col" style={{ width: '80%' }}>
                        <h4 style={{ marginBottom: '5px', marginTop: '5px' }}>Dati del paziente:</h4>
                        <input name="name" onChange={(e) => { setName(e.target.value) }} type="text" className="input" style={{ width: '100%' }} placeholder="Nome"></input>
                        {validator.message('name', name, 'required|alpha_num_space')}
                        {vai === false ? null : <p>{validator.fieldValid('name') === true ? null : 'Assicurati di aver inserito il campo'}</p>}

                        <input onChange={(e) => { setSurname(e.target.value) }} type="text" className="input" style={{ width: '100%', marginTop: '10px' }} placeholder="Cognome"></input>
                        {validator.message('surname', surname, 'required|alpha_num_space')}
                        {vai === false ? null : <p>{validator.fieldValid('surname') === true ? null : 'Assicurati di aver inserito il campo'}</p>}

                        <input onChange={(e) => { setCf(e.target.value) }} type="text" className="input" style={{ width: '100%', marginTop: '10px' }} placeholder="Codice fiscale"></input>
                        {validatorDe.message('cf', cf, 'required|cf')}
                        {vai === false ? null : <p>{validatorDe.fieldValid('cf') === true ? null : 'Assicurati di aver inserito il campo'}</p>}


                        <input onChange={(e) => { setMail(e.target.value) }} type="text" className="input" style={{ width: '100%', marginTop: '10px' }} placeholder="Mail"></input>
                        {validator.message('mail', mail, 'required|email')}

                        {vai === false ? null : <p>{validator.fieldValid('mail') === true ? null : 'Assicurati di aver inserito il campo'}</p>}

                        <input onChange={(e) => { setTel(e.target.value) }} type="text" className="input" style={{ width: '100%', marginTop: '10px' }} placeholder="Telefono"></input>
                        {validator.message('tel', tel, 'required|alpha_num_space')}
                        {vai === false ? null : <p>{validator.fieldValid('tel') === true ? null : 'Assicurati di aver inserito il campo'}</p>}

                        <div style={{ marginTop: '20px', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'flex-start' }}><input type="checkbox"></input> <p style={{ fontWeight: 600 }}>In caso di minore confermo di essere il tutore o il rappresentate legale</p></div>

                    </div>
                </div>

                <div className="input-center" style={{ marginTop: '10px' }}>
                    <div className="col" style={{ width: '80%' }}>
                        <button onClick={() => { setVai(true); checkData() }} className="button margin-top-min" style={{ marginTop: '20px', width: '50%', alignSelf: 'center' }}>Continua</button>
                    </div>
                </div>




            </div>
            <p style={{ marginTop: '40px', fontWeight: 300, marginBottom: '40px', textAlign: 'center' }}>In caso di necessit&agrave; puoi contattare un nostro operatore al numero<br /> <a href='tel:+3908119312726'>081 193 12 726</a> che ti aiutera nella prenotazione.</p>

        </div>
    </>
    );
}

export default N5;